import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scroll to top when navigating via header, footer, or in-app links. */
export function useScrollToTop(): void {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);
}
